import {
  CompanyProductUserType,
  Product,
  ProductDetailsTabsIds
} from '@setvi/shared/interfaces';
import { SInfiniteTable } from '@setvi/shared/components/s-table/infinite';
import { SText, TableLoader } from '@setvi/shared/components';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import { Box } from '@material-ui/core';
// import { ActionBar } from 'componentsV2';
import { CompanySettingsTypeID } from '@setvi/shared/services/react-query/query/user/types';
import { disableSelectProductTooltip } from 'pages/products/components/products-list';
import { useAssociatedProducts } from './useAssociatedProducts';
import { useAssociatedProductColumns } from './useAssociatedProductColumns';
import { ContentTitleContainer } from '../product-info';
import { ProductsEmptyState } from '../../components';

interface AssociatedProductProps {
  product: Product;
  selectedProducts: Product[];
  canSelectProducts: boolean;
  readOnly: boolean;
  handleProductSelect: (isChecked: boolean, product: Product[]) => void;
  openProductDetails?: (
    product: Product,
    defaultOpenedTab?: ProductDetailsTabsIds
  ) => void;
  closeDialog?: () => void;
  handleEmail: () => void;
  handleSelected: () => void;
  handleCloseActionBar: () => void;
}

export const rowKeyGetter = (i: Product) => i.sku;

export const AssociatedProducts = ({
  product,
  selectedProducts,
  canSelectProducts,
  readOnly,
  handleProductSelect,
  openProductDetails,
  closeDialog,
  // @ts-ignore
  handleEmail,
  // @ts-ignore
  handleSelected,
  // @ts-ignore
  handleCloseActionBar
}: AssociatedProductProps) => {
  const { companyData } = useAppContext();
  const userType =
    companyData?.Settings[CompanySettingsTypeID.CompanyType]?.Value;
  const manufacturer = userType === CompanyProductUserType.Manufacturer;
  const { associatedProducts, isLoading } = useAssociatedProducts({ product });

  const { productColums } = useAssociatedProductColumns({
    manufacturer,
    searchQuery: ''
  });

  if (isLoading) return <TableLoader columns={productColums} />;

  if (!associatedProducts.length && !isLoading)
    return <ProductsEmptyState title="No options and accessories found" />;

  const openModal = (prod: Product) => {
    closeDialog?.();
    openProductDetails(prod);
  };

  return (
    <Box flex={1} display="flex" flexDirection="column" width="100%">
      <ContentTitleContainer mb={2}>
        <SText title="Options and Accessories" weight="semibold" />
      </ContentTitleContainer>
      <SInfiniteTable
        newDesign
        stickyHeader={false}
        list={associatedProducts}
        columns={productColums}
        keyGetter={(item: Product) => item?._id}
        row={{
          onClick: (prod: Product) => openModal(prod),
          ...(!readOnly && {
            checkbox: (prod: Product) => {
              const checked = selectedProducts?.some(
                i => rowKeyGetter(i) === rowKeyGetter(prod)
              );
              return {
                checked,
                disabled: !canSelectProducts && !checked,
                tooltip:
                  !canSelectProducts && !checked && disableSelectProductTooltip,
                onChange: e => {
                  handleProductSelect(e.target.checked, [prod]);
                }
              };
            }
          })
        }}
      />

      {/* handleEmail && selectedProducts?.length > 0 && !readOnly && (
        <ActionBar
          selectedProducts={selectedProducts}
          buttonLabel="Email"
          handleEmail={handleEmail}
          handleSelected={handleSelected}
          handleClose={handleCloseActionBar}
        />
      ) */}
    </Box>
  );
};
